<template>
  <div>
    <v-layout row>
      <v-icon @click="goBack">arrow_back</v-icon>
    </v-layout>
    <v-container>
      <v-layout row>
        <h2>
          Editing: {{ specialToEdit.title }}
        </h2>
      </v-layout>
      <v-divider></v-divider>
      <v-layout column style="margin-top: 10px;">
        <v-form ref="editSpecialForm" v-model="valid">
          <v-layout column>
            <v-flex style="margin-bottom: 10px;">
              <v-img max-width="200px" max-height="250px" :src="specialToEdit.imageUrl"></v-img>
            </v-flex>
            <v-flex>
              <v-text-field v-model="specialToEdit.title" :rules="rules" label="Title" id="title" required></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field v-model="specialToEdit.description" :rules="rules" label="Description" id="description"
                required></v-text-field>
            </v-flex>
            <v-flex>
              <datetime input-id="startDate" v-model="specialToEdit.startDate" :rules="rules" input-class="dateTimeInput"
                :week-start="7" auto>
                <label for="startDate" slot="before">Start Date</label>
              </datetime>
            </v-flex>
            <br>
            <v-flex>
              <datetime input-id="endDate" v-model="specialToEdit.endDate" :rules="rules" input-class="dateTimeInput"
                :week-start="7" auto>
                <label for="endDate" slot="before">End Date</label>
              </datetime>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-btn color="success" v-on:click="updateSpecial" :disabled="!valid">Save</v-btn>
          </v-layout>
        </v-form>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";

  export default {
    data() {
      return {
        valid: true,
        rules: [v => !!v || "Required"]
      };
    },
    computed: {
      ...mapGetters({
        specialToEdit: "getSpecialToEdit"
      })
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      updateSpecial() {
        console.log("update");
        this.$store.dispatch("editSpecial", this.specialToEdit);
        this.goBack();
      }
    }
  }

</script>

<style>

</style>
